<template>
  <div>{{date}}</div>
</template>

<script>
export default {
  props: ['date'],
  // props: {
  //   date: Date
  // },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// elapsed.vue?0abf35ed